
/**
 * Custom component for Pancho & Willie's Drink menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.2
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-06-08 (1.0.0) (jhoward)
 *      - <panchoWilliesDrinkSection> adds a two column layout with grid-style pricing for Pancho & Willie's menu sections.
 *
 *    2023-06-21 (1.0.1) (jhoward)
 *      - Add specific CSS rules for the "Cervezas" section in <panchoWilliesDrinkSection>.
 *
 *  2025-04-08 (1.0.2) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <PanchoWillies_drinkSection>.
 *    - Remove "visual_" prefix from class names in <PanchoWillies_drinkSection>.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import PanchoWilliesDefaultSection from "./PanchoWillies_defaultSection.vue";

export default defineComponent({
  name: 'PanchoWillies_drinkSection',
  components: {PanchoWilliesDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
  computed: {
    sectionClasses(): {[key: string]: boolean} {
      return {
        'menu--section-pancho__willies_tequilas': 'tequilas' === this.section.ms_title.toLowerCase(),
        'menu--section-pancho__willies_cervezas': 'cervezas' === this.section.ms_title.toLowerCase(),
      };
    }
  }
})
